export const cn = (...values) => {
  return values
    .flat()
    .filter(Boolean)
    .join(' ');
};
